import createIcon from '../../createIcon';

/**
 * @component @name InstallDesktop
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgMTdINFY1SDEyVjNINEMyLjg5IDMgMiAzLjg5IDIgNVYxN0MyIDE4LjEgMi44OSAxOSA0IDE5SDhWMjFIMTZWMTlIMjBDMjEuMSAxOSAyMiAxOC4xIDIyIDE3VjE0SDIwVjE3WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTE3IDE0TDIyIDlMMjAuNTkgNy41OUwxOCAxMC4xN1YzSDE2VjEwLjE3TDEzLjQxIDcuNTlMMTIgOUwxNyAxNFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const InstallDesktop = createIcon('InstallDesktop', [
  [
    'path',
    {
      d: 'M20 17H4V5H12V3H4C2.89 3 2 3.89 2 5V17C2 18.1 2.89 19 4 19H8V21H16V19H20C21.1 19 22 18.1 22 17V14H20V17Z',
      key: '19yhl3',
    },
  ],
  [
    'path',
    { d: 'M17 14L22 9L20.59 7.59L18 10.17V3H16V10.17L13.41 7.59L12 9L17 14Z', key: '19afxd' },
  ],
]);

export default InstallDesktop;
